<template>
  <div class="toolbar">
    <img class="race-img" src="@/assets/images/RaceSmall.svg" alt="Race">
    <div class="filters">
      <v-text-field
        append-icon="$vuetify.icons.search"
        background-color="white"
        clearable
        dense
        hide-details
        label="Search"
        outlined
        :value="search"
        @input="handleSearch"
      />
    </div>
    <div class="statistics">
      <template v-if="openStats && statistics">
        <div class="statistics-col divider">
          <span>Seasons</span>
          <span class="statistics-col-value">{{ statistics.seasons }}</span>
        </div>
        <div class="statistics-col divider">
          <span>Total Races</span>
          <span class="statistics-col-value">{{ statistics.races.toLocaleString('us') }}</span>
        </div>
        <div class="statistics-col divider">
          <span>Total Images</span>
          <span class="statistics-col-value">{{ statistics.images.toLocaleString('us') }}</span>
        </div>
      </template>
      <div class="statistics-col">
        <v-btn color="primary" icon small @click="handleStats">
          <v-icon>{{ openStats ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
        </v-btn>
        {{ openStats ? 'Close' : 'Stats' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolbarActions',
  props: {
    openStats: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
    },
    statistics: {
      type: Object,
    },
  },
  methods: {
    handleSearch(v) {
      this.$emit('onSearch', v || '')
    },
    handleStats() {
      this.$emit('onStats')
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  align-items: center;
  padding: 9px 26px;
  background: rgba(230, 237, 249, 0.7);
  border-top: 1px solid var(--v-blue-lighten-3);
  border-bottom: 1px solid var(--v-blue-lighten-3);
  backdrop-filter: blur(8px);
  box-shadow: inset 0px -1px 0px var(--v-blue-lighten-2);
}

.race-img {
  grid-column: 5;
  margin-right: 32px;
}

.filters {
  display: flex;
  gap: 8px;
  grid-column: 6/8;
  width: 320px;

  ::v-deep {
    .v-label {
      color: var(--v-blue-lighten-1)!important;
    }

    input {
      color: var(--v-primary-base);
      line-height: 24px;
    }
  }
}

.statistics {
  grid-column: 8/-1;
  display: flex;
  justify-content: flex-end;
}

.statistics-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  &.divider {
    border-right: 1px solid var(--v-blue-lighten-2);
  }

  &:last-child {
    padding-right: 0;
  }
}

.statistics-col-value {
  color: var(--v-primary-base);
  font-size: 18px;
  line-height: 24px;
}

::v-deep {
  .v-text-field {
    fieldset {
      border: 1px solid var(--v-blue-lighten-3);
    }
  }
}
</style>
